<div id="plugins" *ngIf="pluginsFetched" [class]="accessPoint">
  <ng-container *ngIf="item && plugins.length > 0">
    <ng-container *ngFor="let plugin of plugins">
      <plugin [plugin]="plugin" [accessPoint]="accessPoint" [item]="item" [context]="context"></plugin>
    </ng-container>
  </ng-container>
</div>
